import Axios from "axios";
import qs from 'qs'
import { useCommon } from '@/store/useCommon';
import pinia from '@/store'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { elMessage } from "@/utils";

const instance = Axios.create({
  baseURL: '',
  timeout: 60000,
})

const axiosPendingList = []; // 声明一个数组用于存储每个请求的取消函数和axios标识
const cancelToken = Axios.CancelToken; // 用于取消已发送的请求
const removePending = (config) => {
  for (let i in axiosPendingList) {
    if (axiosPendingList[i].url === config.url.split('?')[0]) { // 在当前请求在数组中存在时执行取消函数
      axiosPendingList[i].fn(); // 执行取消操作
      axiosPendingList.splice(Number(i), 1); // 把pendingList记录删掉
    }
  }
}

// 请求拦截
instance.interceptors.request.use((config: AxiosRequestConfig & DefaultObjectType) => {
  removePending(config); // 在一个axios发送前执行一下判定操作，在removePending中执行取消操作
  // config.cancelToken = new cancelToken((c) => {
  //   useCommon().setAxiosArr({ cancelToken: c })
  // })
  if (config && config.noRepetition) {
    config.cancelToken = new cancelToken(function executor(c) { // 本次axios请求的配置添加cancelToken
      axiosPendingList.push({
        url: config.url.split('?')[0],
        fn: c
      });
    })
  }
  if (config?.type == 'upload') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else if (config?.type == 'json') {
    config.headers['Content-Type'] = 'application/json'
  } else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data, {
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    })
  }

  // 格式化data参数
  // config.transformRequest = [function(data, headers) {
  //   return qs.parse(qs.stringify(data,{
  //     arrayFormat: config.arrayFormat || 'indices',
  //     allowDots: true,
  //   }))
  // }]

  // 格式化params参数
  config.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }

  const storeCommon = useCommon()
  // console.log('api', storeCommon.userData)
  // 添加token

  const { token, userData } = storeCommon
  if (token) config.headers['token'] = token
  // console.log('cid',userData.cid[0])
  if (userData.cid) config.headers['cid'] = userData.cid[0] === undefined ? sessionStorage.getItem('currentCid')?sessionStorage.getItem('currentCid'):0  : userData.cid[0]

  return config
}, err => {
  console.error(err)
  return Promise.reject(err)
})


// 满足以下条件退出登录
const logoutByCode = (result) => {
  if (result.data && ["401", "U1004", "U6003", "U6004", "U6005", "U6006", "U6007"].indexOf(result.data.code) > -1) {
    sessionStorage.clear()
    sessionStorage.removeItem('pinia-common')
    setTimeout(() => {
      location.href = "/login"
    }, 300);
  }
}

let isLogoutPromptShown = false;
// 响应拦截
instance.interceptors.response.use((result: AxiosResponse) => {
  const { data } = result
 logoutByCode(result)
  if (data.code === '0') {
    return result
  }
  return result
}, err => {
  const { config, code, message } = err
  if (code === 'ECONNABORTED' || message === 'Network Error') {
    elMessage('error', '网络异常')
  }
  if (err.response) {
    const { status } = err.response;
    // 如果返回 401 状态码，则表示用户未被授权访问该资源
    if (status === 401) {
      // 检查退出提示是否已经显示，如果没有显示，则显示退出提示
      if (!isLogoutPromptShown) {
        isLogoutPromptShown = true;
        sessionStorage.clear()
        sessionStorage.removeItem('pinia-common')
        setTimeout(() => {
          location.href = "/login"
        }, 300);
      } else {
       logoutByCode(err.response)
      }
    }
  }
  return Promise.reject(err)
})

export default instance